<!-- <pzl-card
      [tags]="args.tags"
      [backgroundCover]="_projectPost.postmobilecover"
      [backgroundThumbnail]="_projectPost.postmobilecover"
      [cardTitle]="args.cardTitle"
      [avatar]="args.avatar"
      [name]="args.name"
      [profession]="args.profession"
      [description]="args.description"
    ></pzl-card> -->
<ng-container *ngIf="!loading">
  <div class="box-avulso" [class.progress-visible]="progressVisible" #teste>

    <div class="soon-cover" *ngIf="projectpost.iscommingsoon"
      [ngStyle]="{ 'background-image': 'url(' + projectpost.postmobilecover + ')' }"></div>

    <div class="project-cover" *ngIf="!projectpost.iscommingsoon && !ismycoursespage"
      [ngStyle]="{ 'background-image': 'url(' + projectpost.postmobilecover + ')' }" [routerLink]="projectLink">
      <div class="watch-now">
        <div class="label-watch-now-project icon-only">
          <img src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/icon-watch-now-2020.png" [alt]="projectpost?.title" />
          <div class="text">{{ mosaicoItemTranslation.watchNowText }}</div>
        </div>
      </div>

      <h3 class="box-title">{{ projectpost.title }}</h3>
    </div>

    <div class="ribbon" *ngIf="!hideRibbons && projectpost.iscommingsoon">
      <img src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/ico-ribbon-is-coming-soon.png" alt="Projeto em breve" />
    </div>

    <div class="ribbon" *ngIf="!hideRibbons && projectpost.isnew && !projectpost.iscommingsoon">
      <img src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/ico-ribbon-novo.png" alt="Projeto novo" />
    </div>
    <a class="link-container" [routerLink]="projectLink">
      <div class="link-header">
        <div class="link-header-wrapper">
          <div #headerbg class="header-bg" [style.background-image]="'url(' + projectpost.postthumbnailcover +')'">
          </div>

          <h3 class="box-title-header">{{ projectpost.title }}</h3>
        </div>

        <div class="progress-container" *ngIf="!projectpost.iscommingsoon">
          <h4>{{ mosaicoItemTranslation.progressContainerText }}</h4>

          <unh-spinner-progress
            [value]="progress"
            [diameter]="90"
            [loading]="!(progress >= 0)"
          ></unh-spinner-progress>

          <h3>{{ projectpost.title }}</h3>
        </div>
      </div>

      <div class="link-body" [class.link-body-rounded]="ispro || ismycoursespage">
        <ul class="features-list">
          <li *ngIf="projectpost?.levels?.length > 0">
            <img src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/mosaico/icon-level.png" alt="" />
            <div class="feature-list-item">
              {{ mosaicoItemTranslation.featureListItemLevelText }}

              <span class="feature-list-item-content">
                <ng-container *ngIf="projectpost.levels.length > 1; else singleLevel">
                  {{projectpost.levels[0]}} ao
                  {{projectpost.levels[projectpost.levels.length - 1]}}
                </ng-container>

                <ng-template #singleLevel>
                  {{
                    projectpost.levels.length
                      ? (projectpost.levels | arrayJoin: ' / ')
                      : 'Em breve'
                  }}
                </ng-template>
              </span>
            </div>
          </li>

          <li>
            <img src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/mosaico/icon-clock.png" alt="" />
            <div class="feature-list-item">
              {{ mosaicoItemTranslation.featureListItemDurationText }}
              <span class="feature-list-item-content">
                {{ projectpost.duration }}
              </span>
            </div>
          </li>

          <li>
            <img src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/mosaico/icon-sound.png" alt="" />

            <div class="feature-list-item">
              {{ mosaicoItemTranslation.featureListItemAudio.featureListItemAudioText }}
              <span class="feature-list-item-content">
                {{
                projectpost?.audio?.langs?.length ?
                (projectpost?.audio?.langs | arrayJoin: ' / ') :
                 mosaicoItemTranslation.featureListItemAudio.featureListItemContentText 
                }}
              </span>
            </div>
          </li>

          <li>
            <img src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/mosaico/icon-legends.png" alt="" />

            <div class="feature-list-item">
              {{ mosaicoItemTranslation.featureListItemSubtitles.featureListItemSubtitlesText }}
              <span class="feature-list-item-content">
                {{
                projectpost?.subtitle?.langs?.length ?
                (projectpost?.subtitle?.langs | arrayJoin: ' / ') :
                mosaicoItemTranslation.featureListItemSubtitles.featureListItemContentText
                }}
              </span>
            </div>
          </li>

          <li>
            <img src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/mosaico/icon-teacher.png" alt="" />

            <div class="feature-list-item">
              {{ mosaicoItemTranslation.featureListItemBy.featureListItemByText }}
              <span class="feature-list-item-content">
                {{ projectpost.creator.alias }}
              </span>
            </div>
          </li>

          <li *ngIf="projectpost.softwaretags?.length > 0">
            <img src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/mosaico/icon-software.png" alt="" />

            <div class="feature-list-item">
              {{ mosaicoItemTranslation.featureListItemSoftwareText }}
              <unh-comma-joined-tags [tags]="projectpost?.softwaretags"></unh-comma-joined-tags>
            </div>
          </li>
        </ul>
      </div>

      <div class="box-footer" *ngIf="!ispro && !hidefooter">
        <ng-container *ngIf="isowned; else notOwned">
          <div class="container-price">
            <div class="footer-icon ">
              <mat-icon svgIcon="unh_project_check_blue" style="width: 17px; margin: 0 6px;"></mat-icon>
            </div>

            <div class="footer-info">
              <h3 class="footer-title">{{ mosaicoItemTranslation.boxFooter.footerInfoYourCourseTitle }}</h3>
              <p class="footer-subtitle">{{ mosaicoItemTranslation.boxFooter.footerInfoYourCourseTitle }}</p>
            </div>
          </div>
        </ng-container>

        <ng-template #notOwned>
          <div class="container-price" *ngIf="projectpost?.product?.active">
            <div class="footer-icon">
              <mat-icon svgIcon="unh_project_cart" style="width: 17px; margin: 0 6px;"></mat-icon>
            </div>

            <div class="footer-info">
              <h3 class="footer-title">
                {{ mosaicoItemTranslation.boxFooter.footerInfoBuyForTitle }}

                <ng-container *ngIf="hasActivePromo && projectpost?.product?.pricewithdiscount; else defaultPrice">
                  <span>
                    <unh-old-price-tag [value]="projectpost?.product?.price" textColor="rgba(255,255,255,0.75)"
                      lineColor="rgba(255,255,255,0.75)">
                    </unh-old-price-tag>
                  </span>

                  R$ {{ projectpost?.product?.pricewithdiscount }}
                </ng-container>

                <ng-template #defaultPrice>
                  R$ {{ projectpost?.product?.price }}
                </ng-template>
              </h3>

              <div class="footer-subtitle">
                {{ mosaicoItemTranslation.boxFooter.footerInfoSubscribeSubtitleBeforeMatIcon }}
                <mat-icon svgIcon="unh_pro_outlined_pink" style="width: 29px; height: 14px; margin: -2px 4px 0px;">
                </mat-icon>
                {{ mosaicoItemTranslation.boxFooter.footerInfoSubscribeSubtitleAfterMatIcon }}
              </div>
            </div>
          </div>

          <div class="container-price" *ngIf="!projectpost?.product?.active">
            <div class="footer-icon">
              <mat-icon svgIcon="unh_pro_menu_pink" style="width: 29px;"></mat-icon>
            </div>

            <div class="footer-info">
              <h3 class="footer-title">{{ mosaicoItemTranslation.boxFooter.containerPrice.footerTitle }}</h3>
              <p class="footer-subtitle">{{ mosaicoItemTranslation.boxFooter.containerPrice.footerSubtitle }}</p>
            </div>
          </div>
        </ng-template>

        <div *ngIf="!projectpost.iscommingsoon && hasActivePromo && projectpost?.product?.pricewithdiscount"
          class="promo-discount-tag">
          <unh-promo-tag value="10%" shape="rounded"></unh-promo-tag>
        </div>
      </div>
    </a>
  </div>
</ng-container>

<ng-container *ngIf="loading">
  <div class="box-avulso">
    <unh-fake-project-post-item></unh-fake-project-post-item>
  </div>
</ng-container>
